import { message } from 'antd';
import { AxiosError } from 'axios';
import { I18n } from '@aws-amplify/core';
import { useMutation } from '@tanstack/react-query';

import Api from '@/services/api';

type UpdateRosaInfoRequest = {
	file_id?: string;
	report_id: string;
	report_name: string;
	organization_id: string;
	company_id: string;
	sector_id: string;
	line_id: string;
	workstation_id: string;
	activity_id: string;
	evaluator_id: string;
	collection_date: Date;
	analysis_date: Date;
};

type UpdateRosaInfoResponse = {
	id: string;
	name: string;
	uploaded_date: Date;
	original_name: string;
	workstation_id: string;
	sector_id: string;
	workstation_name: string;
	sector_name: string;
	company_id: string;
	company_name: string;
	organization_id: string;
	organization_name: string;
	duration: string;
	comment: string | null;
	score_section_a: number | null;
	score_section_b: number | null;
	score_section_c: number | null;
	score_section_d: number | null;
	final_score: number;
	collection_date: Date;
	analysis_date: Date;
	activity_id: string;
	line_id: string;
	evaluator_id: string;
	step: number;
};

type UpdateRosaInfoError = AxiosError<any>;

async function updateRosaInfo(params: UpdateRosaInfoRequest): Promise<UpdateRosaInfoResponse> {
	const url = `ergonomic-tool/rosa/basic-info/${params.report_id}`;
	const { data } = await Api.put(url, params);
	return data;
}

export const useUpdateRosaBasicInfo = () => {
	return useMutation<UpdateRosaInfoResponse, UpdateRosaInfoError, UpdateRosaInfoRequest>(
		(payload) => updateRosaInfo(payload),
		{
			onError: () => {
				message.error(I18n.get('Failed to update information'));
			}
		}
	);
};
